import { z } from 'zod'

// ─── Schema principal de publicação ────────────────────────────
// NOTA: campo `cargaSector` NÃO está aqui — é inferido automaticamente no service.

export const publicarFreteSchema = z.object({
  // Rota
  origemCidade:   z.string().min(2, 'Cidade de origem requerida'),
  origemEndereco: z.string().optional(),
  origemLat:      z.number().optional(),
  origemLng:      z.number().optional(),
  destinoCidade:  z.string().min(2, 'Cidade de destino requerida'),
  destinoEndereco: z.string().optional(),
  destinoLat:     z.number().optional(),
  destinoLng:     z.number().optional(),
  distanciaKm:    z.number().int().positive().optional(),

  // Carga — sector NÃO incluído (inferido pelo service)
  cargaTipo:  z.string().min(1, 'Tipo de carga requerido'),
  pesoKg:     z.number().int().positive('Peso requerido'),
  volumeM3:   z.number().positive().optional(),
  instrucoes: z.string().max(1000).optional(),
  valorCarga: z.number().positive().optional(),

  // Veículo — validado contra ConfigVehiculoTipo no service (admin-configurable)
  vehiculoTipo: z.string().min(2).max(30),

  // Temperatura (se refrigerado)
  requiereRefrigeracion: z.boolean().default(false),
  tempMin:               z.number().optional(),
  tempMax:               z.number().optional(),
  requiereSeguro:        z.boolean().default(false),

  // Financeiro
  valorOfertado: z.number().positive().min(10000, 'Valor mínimo: Gs. 10.000').optional(),

  // Datas
  coletaInicio: z.string().datetime({ message: 'Data de coleta inválida' }).optional(),
  coletaFim:    z.string().datetime().optional(),
  entregaPrazo: z.string().datetime({ message: 'Prazo de entrega inválido' }),
})

export const filtroFretesSchema = z.object({
  // Aceita valor único OU múltiplos separados por vírgula ("PUBLICADO,COM_PROPOSTAS")
  // O service.listarFretes já faz split(',') e monta { in: [...] }
  status:         z.string().optional(),
  vehiculoTipo:   z.string().optional(),
  cargaSector:    z.string().optional(),
  origemCidade:   z.string().optional(),
  destinoCidade:  z.string().optional(),
  pesoMinKg:      z.coerce.number().int().optional(),
  pesoMaxKg:      z.coerce.number().int().optional(),
  /** Busca por texto livre — filtra code, origemCidade, destinoCidade, cargaTipo */
  search:         z.string().max(200).optional(),
  /** Paginação baseada em página (alternativa ao cursor) */
  page:           z.coerce.number().int().min(1).default(1),
  cursor:         z.string().optional(),
  pageSize:       z.coerce.number().int().min(1).max(100).default(20),
})

export const propostaSchema = z.object({
  valorProposto: z.number().positive('Valor da proposta requerido'),
  mensagem:      z.string().max(500).optional(),
})

export const confirmarEntregaSchema = z.object({
  comprovanteFotoUrl: z.string().url().optional(),
  observacoes:        z.string().max(1000).optional(),
})

export const avaliarFreteSchema = z.object({
  nota:       z.number().int().min(1).max(5),
  comentario: z.string().max(500).optional(),
})

export type PublicarFreteInput  = z.infer<typeof publicarFreteSchema>
export type FiltroFretesInput   = z.infer<typeof filtroFretesSchema>
export type PropostaInput       = z.infer<typeof propostaSchema>
export type ConfirmarEntregaInput = z.infer<typeof confirmarEntregaSchema>
export type AvaliarFreteInput   = z.infer<typeof avaliarFreteSchema>
